var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'base-cause-square',
    { 'big-cause': _vm.bigCause },
    { colorize: _vm.hoverable },
    { 'force-color': !_vm.hoverable}
  ],on:{"click":_vm.onClick}},[(_vm.hoverable && _vm.causeItem && _vm.causeIdx != 18)?[_c('router-link',{attrs:{"to":_vm.causeLink}},[_c('div',{staticClass:"cause-image"},[_c('img',{attrs:{"src":_vm.iconSrc}})])])]:[_c('div',{staticClass:"cause-image"},[_c('img',{attrs:{"src":_vm.iconSrc}})])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }